module.exports = __webpack_public_path__ + "static/media/bulk_resource_vetting_request.8ac448f6.csv";